<script>
import { throttle } from 'lodash';

export default {
  name: 'ICollapseItem',
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isCollapsed: true,
      contentHeight: 0,
    };
  },
  watch: {
    isCollapsed() {
      this.calculateContentHeight();
    },
  },
  mounted() {
    this.calculateContentHeight();
    this.throttledResizeHandler = throttle(this.calculateContentHeight, 50);
    window.addEventListener('resize', this.throttledResizeHandler);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.throttledResizeHandler);
  },
  methods: {
    calculateContentHeight() {
      this.$nextTick(() => {
        const content = this.$refs.Content;
        if (content) {
          this.contentHeight = content.scrollHeight;
        }
      });
    },
  },
};
</script>

<template>
  <div
    class="collapse-item tw-flex tw-flex-col tw-rounded-3xl tw-border tw-border-gray dark:tw-border-dm-gray tw-overflow-hidden"
  >
    <div
      class="header tw-flex tw-items-center tw-justify-between tw-p-4 tw-pl-6 tw-w-full tw-cursor-pointer"
      @click="isCollapsed = !isCollapsed"
    >
      <h4 class="tw-text-xl">
        {{ title }}
      </h4>
      <div class="tw-flex tw-items-center tw-justify-center tw-rounded-[10px] tw-min-w-10 tw-min-h-10 tw-bg-light">
        <icon-angle-down
          class="tw-transition-transform tw-duration-150 tw-ease-out"
          :class="isCollapsed ? 'tw-rotate-0' : 'tw-rotate-180'"
        />
      </div>
    </div>

    <div
      ref="Wrapper"
      class="wrapper tw-overflow-hidden tw-transition-[max-height] tw-duration-300 ease-out"
      :style="{ maxHeight: isCollapsed ? '0px' : `${contentHeight}px` }"
    >
      <div
        ref="Content"
        class="content tw-pb-4"
      >
        <slot name="content" />
      </div>
    </div>
  </div>
</template>

<style scoped>
.collapse-item .wrapper {
  max-height: 0;
}
</style>
